import PriceText from './fields/PriceText';
import * as React from 'react';
import IPremiumFee from '../classes/IPremiumFee';

const PremiumPrice: React.FunctionComponent<{ premium?: IPremiumFee[] | null }> = (props) => {
  return props.premium !== null && props.premium !== undefined && props.premium.length !== 1 ? (
    <span>Conflict</span>
  ) : (
    <PriceText price={props.premium === null || props.premium === undefined ? null : props.premium[0].total} />
  );
};

export default PremiumPrice;
